import React, { useMemo } from 'react'
import { Typography } from 'antd'
import produce from 'immer'
import { includes, isNil } from 'lodash'
import PropTypes from 'prop-types'

import { StyledNoMarginFormItem } from '../../../core/components/styled'

import { ALL_SELECT_OPTION_ITEM } from '../../constants'
import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormItemLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

import Select from './select'

const FormSelect = ({
  name,
  label,
  options,
  mode,
  rules,
  labelAbove,
  showAllOption,
  showColon,
  ...rest
}) => {
  const optionsWithAll = useMemo(
    () =>
      showAllOption && includes(['multiple', 'tags'], mode)
        ? produce(options, newOptions => {
            newOptions.unshift(ALL_SELECT_OPTION_ITEM)
            return newOptions
          })
        : options,
    [showAllOption, mode, options],
  )

  if (isNil(label)) {
    return (
      <StyledNoMarginFormItem name={name} rules={rules}>
        <Select
          name={name}
          label={label}
          options={optionsWithAll}
          mode={mode}
          {...rest}
        />
      </StyledNoMarginFormItem>
    )
  }

  return (
    <StyledNoMarginFormItem
      labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
      name={name}
      label={
        <Typography.Text>
          {formatFormItemLabel(label, showColon)}
        </Typography.Text>
      }
      rules={rules}
    >
      <Select
        name={name}
        label={label}
        options={optionsWithAll}
        mode={mode}
        {...rest}
      />
    </StyledNoMarginFormItem>
  )
}

FormSelect.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  mode: PropTypes.oneOf(['multiple', 'tags']),
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  labelAbove: PropTypes.bool,
  showAllOption: PropTypes.bool,
  showColon: PropTypes.bool,
}

FormSelect.defaultProps = {
  label: undefined,
  mode: undefined,
  rules: undefined,
  labelAbove: false,
  showAllOption: false,
  showColon: false,
}

export default FormSelect
